import { takeEvery, put, call, all } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getUserList(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-users?page=" + actions.page
        : apiUrl + "/opa-users" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "LIST_USER_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_USER_RESPONSE_GET", value: error });
  }
}

function* getUser(actions) {

  let uuid = actions.idUser ? actions.idUser : getSetCookie()

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-user/"
        : apiUrl + "/opa-user/" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "USER_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "USER_RESPONSE_GET", value: error });
  }
}

function* getUserByEmail(actions) {

  let uuid = actions.idUser ? actions.idUser : getSetCookie()

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-user-by-email/"
        : apiUrl + "/opa-user-by-email/" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "USER_RESPONSE_BY_EMAIL_GET", value: response });
  } catch (error) {
    yield put({ type: "USER_RESPONSE_BY_EMAIL_GET", value: error });
  }
}

function* getUserPermissions(actions) {
  const additionalUserData = JSON.parse(window.localStorage.getItem('additionalUserData'));
  let uuid = ""
  if (additionalUserData.roles?.includes("ROLE_SUPERUSER")) {
    uuid = actions.idUser ? actions.idUser : getSetCookie()
  } else {
    uuid = getSetCookie()
  }
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-user/"
        : apiUrl + "/opa-user/" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "USER_PERMISSIONS_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "USER_PERMISSIONS_RESPONSE_GET", value: error });
  }
}

function* resetUser() {
  yield put({ type: "USER_RESPONSE_RESET" });
}

function* createUser(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-user";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.created) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "USER_RESPONSE_CREATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "USER_RESPONSE_CREATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* updateUser(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-user/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.updatedAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "USER_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });

  } catch (error) {
    yield put({
      type: "USER_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}


function* updatePassword(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-change-password";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status === 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "PASSWORD_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "PASSWORD_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

export function* getSagaUserList() {
  yield takeEvery("GET_LIST_USER", getUserList);
}

export function* getSagaUser() {
  yield takeEvery("GET_USER", getUser);
}

export function* getSagaUserByEmail() {
  yield takeEvery("GET_USER_BY_EMAIL", getUserByEmail);
}

export function* getSagaUserPermissions() {
  yield takeEvery("GET_USER_PERMISSIONS", getUserPermissions);
}

export function* resetSagaUser() {
  yield takeEvery("RESET_USER", resetUser);
}

export function* updateSagaUser() {
  yield takeEvery("UPDATE_USER", updateUser);
}

export function* sagaCreateUser() {
  yield takeEvery("CREATE_USER", createUser);
}

export function* updateSagaPassword() {
  yield takeEvery("UPDATE_SAGA_PASSWORD", updatePassword);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};




